import Twig from 'twig';
import Media from './../mediaDetect.js'; //Детектор медиа
import Scrollbar from './scrollbar.js';
import Sidenav from './sidenav.js';

let Search = {
    open: function(){
        let _body = $('body'),
            search = $('[data-search]'),
            headerFixed = $('[data-header-content]');

        if (!_body.hasClass('search-opened')){

            if(Scrollbar.isActive()){
                let widthScrollbar = Scrollbar.getWidth();

                _body.css('padding-right', widthScrollbar + 'px');
                search.css('right', widthScrollbar + 'px');

                if(Media.detect().isMobile || Media.detect().isTablet){
                    headerFixed.css('padding-right', widthScrollbar + 'px');
                }
            }

            _body.addClass('search-opened');
            // Класс для фиксирование шапки и скрытия поздравления ген.директора
            _body.addClass('fixed-header-open-sidenav');

            search.animate({height: '100vh'}, 300);
        }
    },
    close: function(openMenu){
        let _body = $('body'),
            search = $('[data-search]'),
            headerFixed = $('[data-header-content]');

        search.animate({height: '0px'}, 300,
            function(){

                _body.removeClass('search-opened').removeAttr('style');
                headerFixed.removeAttr('style');
                search.css('right', '').removeAttr('style');

                if(openMenu) {
                    Sidenav.openMenu($('[data-sidenav-menu]'));
                }else{
                    // Убираем фиксирование шапки и отображаем поздравление ген.директора
                    _body.removeClass('fixed-header-open-sidenav');
                }

                Search.clearSearch();
            }
        );
    },
    toggle: function(){
        if ($('body').hasClass('search-opened')){
            Search.close();
        } else {
            Search.open();
        }
    },
    isOpen: function(){
        return $('body').hasClass('search-opened');
    },
    submitForm: function(form){
        form.on('submit', function(e){
            e.preventDefault();

            let fields = form.serialize();

            if(fields) {
                $.ajax({
                    url: '/'+window.langId+'/ajax/search.php',
                    //url: '/local/ajax/nosearch.json',
                    data: fields,
                    dataType: 'json',
                    beforeSend: function(){},
                    success: function(_data){
                        let search = $('[data-search]'),
                            resultSearch = search.find('[data-result-search]'),
                            noresultSearch = search.find('[data-noresult-search]');

                        if(_data.items.length > 0){
                            let listResult = resultSearch.find('[data-list-result-search]'),
                                valueResult = resultSearch.find('[data-value-result-search]'),
                                countResult = resultSearch.find('[data-count-result-search]');

                            listResult.empty();
                            var linkTitle = window.langId == 'ru' ? 'Перейти на страницу' : 'Go to page'
                            var template = Twig.twig({
                                data:   '<div class="item">'+
                                            '<div class="item__title">{{ data.title|raw }}</div>'+
                                            '<div class="item__descr">{{ data.descr|raw }}</div>'+
                                            '<div class="item__link">'+
                                    '<a href="{{ data.link }}">' + linkTitle + '</a>'+
                                            '</div>'+
                                        '</div>'
                            });

                            _data.items.forEach(function(item, i){
                                listResult.append($(template.render({
                                    data: {
                                        link: item.link,
                                        titleLink: item.titleLink,
                                        title: item.title,
                                        descr: item.descr
                                    }
                                })));
                            });

                            valueResult.text(_data.q);
                            countResult.text(_data.items.length);

                            search.removeClass('open-no-result').addClass('open-result');

                        } else {
                            search.removeClass('open-result').addClass('open-no-result');

                            noresultSearch.find('[data-novalue-result-search]').text(_data.q);
                        }
                    }
                });
            }
        });
    },
    clearSearch: function(){
        let search = $('[data-search]'),
            listResult = search.find('[data-list-result-search]'),
            inputSearch = search.find('[data-input-search]');

        listResult.empty();
        search.removeClass('open-no-result').removeClass('open-result');

        inputSearch.val('').removeAttr('style');
    }
}

$(document).ready(function() {

    Search.submitForm($('[data-form-search]'));

    $('[data-input-search]').on('input', function(){
        let _this = $(this),
            form = _this.closest('[data-form-search]'),
            hiddenText = form.find('[data-hidden-text-search]'),
            input = form.find('[data-input-search]');
        
        hiddenText.text(_this.val());
    });

    $('[data-btn-open-search]').on('click', function(){
        if(Sidenav.isOpenMenu()) {
            Sidenav.closeMenu($('[data-sidenav-menu]'), true);
        }else{
            Search.open();
        }
    });

    $('[data-btn-close-search]').on('click', function(){
        Search.close();
    });

    $('[data-open-form-search]').on('click', function(){
        Search.clearSearch();
        $('[data-search]').removeClass('open-no-result');
    });

    // обрабатываем изменение точки остановки или старт страницы
    $(window).on('mdbreakpoint', function(e, breakpointOld, breakpointOldNew) {

        if(Search.isOpen()) {
            if(Media.detect().isMobile || Media.detect().isTablet){
                $('[data-header-content]').css('padding-right', Scrollbar.getWidth() + 'px');
            }else{
                $('[data-header-content]').removeAttr('style');
            }
        }        
    });
});

export default {
    open: Search.open,
    close: Search.close,
    toggle: Search.toggle,
    isOpen: Search.isOpen
};


// WEBPACK FOOTER //
// ./components/search.js